import { Fragment, useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Space, Tooltip, Row, Col, Input, Select, Form, DatePicker, message } from 'antd';
import { get, post } from '@/core/request';
import dayjs from 'dayjs';
import './UserGroups.less';
import PageHeader from '@components/PageHeader/PageHeader';

const { TextArea } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;

export default function UserGroup() {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';

    // 通过路由参数判定模式：/uc/user-groups/new 为新增；/uc/user-groups/:id 为详情
    const id = params?.id && params.id !== 'new' ? params.id : null;
    const isEdit = !!id;
    // 兼容历史调用方通过 state 传 row 的场景
    const stateRow = location.state?.row;
    const editId = id || stateRow?.id || null;

    const [titleName, setTitleName] = useState('');
    const [ListLength, setListLength] = useState(0);

    const pageFormItemLayout = {
        labelCol: {
            sm: { span: 5 },
            md: { span: 5 },
            lg: { span: 3 },
            xl: { span: 3 },
            xxl: { span: 3 },
        },
        wrapperCol: {
            sm: { span: 14 },
            md: { span: 14 },
            lg: { span: 13 },
            xl: { span: 13 },
            xxl: { span: 10 },
        },
    };

    const [form] = Form.useForm();

    const [groupList, setGroupList] = useState({
        queryType: 0,
        name: '',
        displayName: '',
        remark: '',
        list: [],
    });

    const [registerTime, setRegisterTime] = useState({
        startTime: '',
        endTime: '',
    });
    const [identityTime, setIdentityTime] = useState({
        startTime: '',
        endTime: '',
    });
    const [lastTime, setLastTime] = useState({
        startTime: '',
        endTime: '',
    });

    // 进入详情：根据 id 获取分群信息
    useEffect(() => {
        if (isEdit && editId) {
            get(`/user/data/user-group/info`, {
                id: editId,
            }).then(res => {
                if (res.status_code === 200) {
                    res.data.list
                        && res.data.list.forEach(item => {
                            item.paramMap
                                && item.paramMap.list?.forEach(elem => {
                                    const param = elem.param || '';
                                    const [startTime, endTime] = param.split('/');
                                    if (elem.code === '<time>member.mem_regist_time') {
                                        setRegisterTime({ startTime, endTime });
                                    } else if (elem.code === '<time>member.mem_examine_time') {
                                        setIdentityTime({ startTime, endTime });
                                    } else if (elem.code === '<time>member.mem_lastest_login_time') {
                                        setLastTime({ startTime, endTime });
                                    }
                                });
                        });
                    form.setFieldsValue({
                        name: res.data.name,
                        displayName: res.data.displayName,
                        remark: res.data.remark,
                    });
                    setGroupList(res.data);
                    setTitleName(res.data.name || '');
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editId]);

    useEffect(() => {
        document.title = isEdit ? '用户分群详情-用户中心' : '新增用户分群-用户中心';
    }, [isEdit]);

    // 点击添加最外层
    const handleAddOut = () => {
        const outObj = {
            list: [{ code: undefined, value2: undefined, param: undefined }],
            queryType: 0,
        };
        setListLength(ListLength + 1);
        groupList.list.push({ paramMap: outObj });
        setGroupList({
            ...groupList,
            list: groupList.list,
        });
    };

    // 点击添加内层
    const handleAddInner = outIndex => {
        return () => {
            const outList = groupList.list.map((item, index) => {
                if (index === outIndex) {
                    const { list } = item.paramMap;
                    const innerList = [...list];
                    innerList.splice(innerList.length, 0, {
                        code: undefined,
                        value2: undefined,
                        param: undefined,
                    });
                    return {
                        paramMap: {
                            ...item.paramMap,
                            list: innerList,
                        },
                    };
                }
                return item;
            });
            setListLength(ListLength + 1);
            setGroupList({
                ...groupList,
                list: outList,
            });
        };
    };
    // 删除
    const handleDelete = (outIndex, innerIndex) => {
        return () => {
            let arr = [];
            groupList.list.forEach((item, index) => {
                if (index === outIndex) {
                    if (item.paramMap.list.length === 1) {
                        arr = groupList.list.filter((item, index) => index !== outIndex);
                    } else {
                        arr = groupList.list.map((item, index) => {
                            if (index === outIndex) {
                                if (item.paramMap.list.length !== 1) {
                                    return {
                                        paramMap: {
                                            ...item.paramMap,
                                            list: item.paramMap.list.filter((item, index) => index !== innerIndex),
                                        },
                                    };
                                }
                            }
                            return item;
                        });
                    }
                }
            });
            setListLength(ListLength - 1);
            setGroupList({
                ...groupList,
                list: arr,
            });
        };
    };

    // 外部的且或更改
    const handleChangeOutRelation = () => {
        setGroupList({
            ...groupList,
            queryType: groupList.queryType === 0 ? 1 : 0,
        });
    };

    // 内部的且或更改
    const handleChangeInnerRelation = outIndex => {
        return () => {
            const arr = groupList.list.map((item, index) => {
                if (index === outIndex) {
                    return {
                        paramMap: {
                            ...item.paramMap,
                            queryType: item.paramMap.queryType === 0 ? 1 : 0,
                        },
                    };
                }
                return item;
            });
            setGroupList({
                ...groupList,
                list: arr,
            });
        };
    };

    // inner内容改变
    const handleChangeValue = (type, outIndex, innerIndex) => {
        return (value, dateString) => {
            let arr = [];
            let data = value;
            // input
            if (Object.prototype.toString.call(value) === '[object Object]') {
                data = value.target.value;
            }
            arr = groupList.list.map((outItem, outI) => {
                if (outI === outIndex) {
                    return {
                        paramMap: {
                            ...outItem.paramMap,
                            list: outItem.paramMap.list.map((innerItem, innerI) => {
                                if (innerI === innerIndex) {
                                    if (innerItem.code === '<time>member.mem_regist_time' || innerItem.code === '<time>member.mem_examine_time' || innerItem.code === '<time>member.mem_lastest_login_time') {
                                        if (type === 'param') {
                                            data = `${dateString[0]}/${dateString[1]}`;
                                        }
                                    }
                                    if (
                                        innerItem.code === 'member_detail.mem_office'
                                        || innerItem.code === 'member_detail.mem_post'
                                        || innerItem.code === 'member_detail.mem_jobtitle'
                                        || innerItem.code === 'member_detail.mem_sex'
                                        || innerItem.code === 'member_detail.mem_identity'
                                        || innerItem.code === 'member.mem_device_type'
                                    ) {
                                        if (type === 'param') {
                                            var ids = [];
                                            value.forEach(item => {
                                                ids.push(item);
                                            });
                                            data = ids.join(',');
                                        }
                                    }
                                    return {
                                        ...innerItem,
                                        [type]: data,
                                    };
                                }
                                return innerItem;
                            }),
                        },
                    };
                }
                return outItem;
            });
            // change第一个 第三个置为空
            if (type === 'code') {
                arr = groupList.list.map((outItem, outI) => {
                    if (outI === outIndex) {
                        return {
                            paramMap: {
                                ...outItem.paramMap,
                                list: outItem.paramMap.list.map((innerItem, innerI) => {
                                    if (innerI === innerIndex) {
                                        return {
                                            ...innerItem,
                                            code: data,
                                            value2: undefined,
                                            param: undefined,
                                        };
                                    }
                                    return innerItem;
                                }),
                            },
                        };
                    }
                    return outItem;
                });
            }
            if (arr) {
                arr.map(item => {
                    item.paramMap.list.map(elem => {
                        switch (elem.code) {
                            case 'member.mem_card':
                                elem.value2 = 'equal';
                                break;
                            case 'member.mem_mobile':
                                elem.value2 = 'equal';
                                break;
                            case 'member.mem_email':
                                elem.value2 = 'equal';
                                break;
                            case 'member_detail.mem_sex':
                                elem.value2 = 'equal';
                                break;
                            case 'member_detail.mem_identity':
                                elem.value2 = 'equal';
                                break;
                            case 'member_detail.mem_office':
                                elem.value2 = 'equal';
                                break;
                            case 'member_detail.mem_post':
                                elem.value2 = 'equal';
                                break;
                            case 'member_detail.mem_jobtitle':
                                elem.value2 = 'equal';
                                break;
                            case 'member.mem_device_type':
                                elem.value2 = 'equal';
                                break;
                            case '<time>member.mem_regist_time':
                                elem.value2 = 'range';
                                break;
                            case '<time>member.mem_examine_time':
                                elem.value2 = 'range';
                                break;
                            case '<time>member.mem_lastest_login_time':
                                elem.value2 = 'range';
                                break;
                        }
                        return elem;
                    });
                    return item;
                });
            }
            setGroupList({
                ...groupList,
                list: arr,
            });
        };
    };

    // 科室
    const [officeData, setOfficeData] = useState([]);
    // 职务
    const [postData, setPostData] = useState([]);
    // 职称
    const [titleData, setTitleData] = useState([]);

    // 科室 职务 职称
    useEffect(() => {
        get('user/dictionary/office/detail', { type: 2 }).then(res => {
            setOfficeData(res.data);
        });
        get('/user/dictionary/board', { type: 3 }).then(res => {
            setPostData(res.data);
        });
        get('/user/dictionary/board', { type: 4 }).then(res => {
            setTitleData(res.data);
        });
    }, []);

    // 点击取消
    const handleClose = () => {
        form.resetFields();
        setGroupList({
            queryType: 0,
            name: '',
            displayName: '',
            remark: '',
            list: [],
        });
    };

    // 点击提交
    const onFinish = values => {
        let finishBool = true;
        if (groupList.list.length !== 0) {
            groupList.list.forEach(item => {
                item.paramMap.list.forEach(elem => {
                    if (!elem.code || !elem.value2 || !elem.param) {
                        message.error('请检查分群规则是否填全');
                        finishBool = false;
                        return;
                    }
                });
            });
            if (finishBool) {
                const updatedGroupList = {
                    ...groupList,
                    name: `${values.name}`,
                    displayName: values.displayName,
                    remark: values.remark,
                };
                const string = JSON.stringify(updatedGroupList);
                post(`/user/data/user-group/save`, string).then(res => {
                    if (res.status_code === 200) {
                        message.success(res.message);
                        navigate('/uc/user-groups');
                    }
                });
            }
        } else {
            message.error('分群规则不能为空');
        }
    };

    return (
        <Fragment>
            <PageHeader
                title={
                    <>
                        <i className="bi bi-chevron-left page-header-back-btn" onClick={() => navigate('/uc/user-groups')} />
                        <span>{isEdit ? '用户分群详情' : '新增用户分群'}</span>
                    </>
                }
                breadcrumb={[{ label: '用户中心', path: '/uc' }, { label: '用户分群', path: '/uc/user-groups' }, isEdit ? titleName || '用户分群详情' : '新增用户分群']}
            />

            <div className="page-route-body">
                <div className="main-content-title">基本信息</div>
                <Form className="page-form" {...pageFormItemLayout} form={form} onFinish={onFinish}>
                    <div className="basic-message">
                        {!isEdit ? (
                            <Form.Item
                                name="name"
                                label="分群名称"
                                help=""
                                required={true}
                                rules={[
                                    {
                                        validator: (_, value) => {
                                            if (value === undefined) {
                                                return Promise.reject('分群名称不能为空');
                                            } else {
                                                return Promise.resolve();
                                            }
                                        },
                                    },
                                ]}
                            >
                                <Input showCount maxLength={30} placeholder="输入分群名称" allowClear autoComplete="off" />
                            </Form.Item>
                        ) : (
                            <Form.Item name="name" label="分群名称" required={true}>
                                <Input placeholder="输入分群名称" allowClear autoComplete="off" disabled />
                            </Form.Item>
                        )}

                        <Form.Item name="remark" label="备注">
                            <TextArea rows={3} placeholder="输入备注信息" allowClear autoComplete="off" disabled={isEdit} showCount maxLength={50} />
                        </Form.Item>
                    </div>

                    <div className="main-content-title">分群规则</div>

                    <Row className="user-group-rules-space">
                        <Col span={3} style={{ textAlign: 'right' }}>
                            <span>创建规则：</span>
                        </Col>
                        <Col span={20}>
                            <div className="user-groups-box">
                                <div className="user-groups-box-header">
                                    <Row>
                                        <Col span={12}>
                                            <h3>用户属性满足</h3>
                                        </Col>

                                        {!isEdit && ListLength < 5 && (
                                            <Col span={12} style={{ textAlign: 'right' }}>
                                                <div onClick={handleAddOut} className="user-add-box">
                                                    <i className="bi bi-plus-circle-fill"></i>
                                                    添加
                                                </div>
                                            </Col>
                                        )}
                                    </Row>
                                </div>

                                <div className={groupList.list && groupList.list.length > 1 ? 'edit-condition-box' : 'edit-condition-box-noborder'}>
                                    {groupList.list && groupList.list.length > 1 && (
                                        <span className={!isEdit ? 'edit-condition-box-queryType' : 'edit-condition-box-queryType disable-click'} onClick={handleChangeOutRelation}>
                                            {groupList.queryType === 0 ? '或' : '且'}
                                        </span>
                                    )}
                                    {groupList.list
                                        && groupList.list.map((outItem, outIndex) => {
                                            const { list, queryType } = outItem.paramMap || {};
                                            return (
                                                <div key={outIndex} className={list && list.length > 1 ? 'edit-condition-box' : 'edit-condition-box-noborder'}>
                                                    {list && list.length > 1 && (
                                                        <span className={!isEdit ? 'edit-condition-box-queryType' : 'edit-condition-box-queryType disable-click'} onClick={handleChangeInnerRelation(outIndex)}>
                                                            {queryType === 0 ? '或' : '且'}
                                                        </span>
                                                    )}

                                                    <div className="inner-content-box">
                                                        {list
                                                            && list.map((innerItem, innerIndex) => {
                                                                const { code, value2, param } = innerItem;
                                                                return (
                                                                    <Row key={innerIndex} gutter={16} className="inner-content">
                                                                        <Col className="gutter-row" span={6}>
                                                                            <Select placeholder="请选择用户属性" value={code} style={{ width: '100%' }} disabled={isEdit} onChange={handleChangeValue('code', outIndex, innerIndex)}>
                                                                                <Option value="member.mem_card">用户唯一标识</Option>
                                                                                <Option value="member.mem_nickname">昵称</Option>
                                                                                <Option value="member_detail.mem_username">真实姓名</Option>
                                                                                <Option value="member_detail.mem_sex">性别</Option>
                                                                                <Option value="member.mem_mobile">手机号</Option>
                                                                                <Option value="member.mem_email">邮箱</Option>
                                                                                <Option value="member_detail.mem_identity">身份</Option>
                                                                                <Option value="member_detail.mem_unit">单位名称</Option>
                                                                                <Option value="member_detail.mem_office">科室</Option>
                                                                                <Option value="member_detail.mem_post">职务</Option>
                                                                                <Option value="member_detail.mem_jobtitle">职称</Option>
                                                                                <Option value="<time>member.mem_regist_time">注册时间</Option>
                                                                                <Option value="member.mem_device_type">注册端口</Option>
                                                                                <Option value="<time>member.mem_examine_time">认证审核时间</Option>
                                                                                <Option value="<time>member.mem_lastest_login_time">最后登录时间</Option>
                                                                            </Select>
                                                                        </Col>
                                                                        {/* 用户唯一标识    手机号    邮箱*/}
                                                                        {code === 'member.mem_card' || code === 'member.mem_mobile' || code === 'member.mem_email' ? (
                                                                            <Fragment>
                                                                                <Col className="gutter-row" span={4}>
                                                                                    <Select value="equal" disabled style={{ width: '100%' }}>
                                                                                        <Option value="equal">等于</Option>
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col className="gutter-row" span={7}>
                                                                                    <Input
                                                                                        disabled={isEdit}
                                                                                        allowClear
                                                                                        value={param}
                                                                                        placeholder={code === 'member.mem_card' ? '输入用户唯一标识(mem_card)' : code === 'member.mem_mobile' ? '输入用户手机号' : '输入用户邮箱'}
                                                                                        autoComplete="off"
                                                                                        onChange={handleChangeValue('param', outIndex, innerIndex)}
                                                                                    />
                                                                                    {!isEdit && code === 'member.mem_card' && (
                                                                                        <Tooltip placement="right" title="单个 mem_card 或英文逗号隔开的 mem_card列表，不超过100个">
                                                                                            <span className="user-group-tooltip">
                                                                                                <i className="bi bi-info-circle-fill"></i>
                                                                                            </span>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                </Col>
                                                                            </Fragment>
                                                                        ) : (
                                                                            <Fragment></Fragment>
                                                                        )}

                                                                        {/* 昵称    真实姓名    单位名称*/}
                                                                        {code === 'member.mem_nickname' || code === 'member_detail.mem_username' || code === 'member_detail.mem_unit' ? (
                                                                            <Fragment>
                                                                                <Col className="gutter-row" span={4}>
                                                                                    <Select placeholder="请选择条件" value={value2} style={{ width: '100%' }} disabled={isEdit} onChange={handleChangeValue('value2', outIndex, innerIndex)}>
                                                                                        <Option value="equal">等于</Option>
                                                                                        <Option value="include">包含</Option>
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col className="gutter-row" span={7}>
                                                                                    <Input
                                                                                        value={param}
                                                                                        allowClear
                                                                                        autoComplete="off"
                                                                                        disabled={isEdit}
                                                                                        placeholder={code === 'member.mem_nickname' ? '输入用户昵称' : code === 'member_detail.mem_username' ? '输入用户真实姓名' : '输入用户单位名称'}
                                                                                        onChange={handleChangeValue('param', outIndex, innerIndex)}
                                                                                    />
                                                                                    {!isEdit && (
                                                                                        <Tooltip placement="right" title={value2 === 'equal' ? '单个昵称或英文逗号隔开的昵称列表，不超过100个' : '昵称中包含该关键词，不含空格'}>
                                                                                            <span className="user-group-tooltip">
                                                                                                <i className="bi bi-info-circle-fill"></i>
                                                                                            </span>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                </Col>
                                                                            </Fragment>
                                                                        ) : (
                                                                            <Fragment></Fragment>
                                                                        )}
                                                                        {/* 性别    身份    科室    职务    职称    注册端口*/}
                                                                        {code === 'member_detail.mem_sex' || code === 'member_detail.mem_identity' || code === 'member_detail.mem_office' || code === 'member_detail.mem_post' || code === 'member_detail.mem_jobtitle' || code === 'member.mem_device_type' ? (
                                                                            <Fragment>
                                                                                <Col className="gutter-row" span={4}>
                                                                                    <Select value="equal" disabled style={{ width: '100%' }}>
                                                                                        <Option value="equal">等于</Option>
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col className="gutter-row" span={7}>
                                                                                    {code === 'member_detail.mem_sex' && (
                                                                                        <Select value={param ? param.split(/[,]/) : undefined} placeholder="请选择性别" mode="multiple" onChange={handleChangeValue('param', outIndex, innerIndex)} disabled={isEdit}>
                                                                                            <Select.Option value="0">女</Select.Option>
                                                                                            <Select.Option value="1">男</Select.Option>
                                                                                        </Select>
                                                                                    )}
                                                                                    {code === 'member_detail.mem_identity' && (
                                                                                        <Fragment>
                                                                                            <Select value={param ? param.split(/[,]/) : undefined} placeholder="请选择身份" mode="multiple" onChange={handleChangeValue('param', outIndex, innerIndex)} disabled={isEdit}>
                                                                                                <Select.Option value="A01">医务人员</Select.Option>
                                                                                                <Select.Option value="A02">政府官员</Select.Option>
                                                                                                <Select.Option value="A03">商业人士</Select.Option>
                                                                                                <Select.Option value="A04">教育科研人士</Select.Option>
                                                                                                <Select.Option value="A06">社会团体人士</Select.Option>
                                                                                            </Select>
                                                                                        </Fragment>
                                                                                    )}
                                                                                    {code === 'member_detail.mem_office' && (
                                                                                        <Select value={param ? param.split(/[,]/) : undefined} placeholder="请选择科室" mode="multiple" onChange={handleChangeValue('param', outIndex, innerIndex)} disabled={isEdit} showSearch={{ optionFilterProp: 'children' }}>
                                                                                            {officeData
                                                                                                && officeData.map(item => {
                                                                                                    return (
                                                                                                        <Select.OptGroup label={item.dicName} key={item.dicCode}>
                                                                                                            {item.child.length !== 0
                                                                                                                && item.child.map(elem => {
                                                                                                                    return (
                                                                                                                        <Select.Option key={elem.dicCode} value={elem.dicCode}>
                                                                                                                            {elem.dicName}
                                                                                                                        </Select.Option>
                                                                                                                    );
                                                                                                                })}
                                                                                                        </Select.OptGroup>
                                                                                                    );
                                                                                                })}
                                                                                        </Select>
                                                                                    )}
                                                                                    {code === 'member_detail.mem_post' && (
                                                                                        <Select value={param ? param.split(/[,]/) : undefined} placeholder="请选择职务" mode="multiple" onChange={handleChangeValue('param', outIndex, innerIndex)} disabled={isEdit} showSearch={{ optionFilterProp: 'children' }}>
                                                                                            {postData
                                                                                                && postData.map(item => {
                                                                                                    return (
                                                                                                        <Select.Option key={item.dicCode} value={item.dicCode}>
                                                                                                            {item.dicName}
                                                                                                        </Select.Option>
                                                                                                    );
                                                                                                })}
                                                                                        </Select>
                                                                                    )}
                                                                                    {code === 'member_detail.mem_jobtitle' && (
                                                                                        <Select value={param ? param.split(/[,]/) : undefined} placeholder="请选择职称" mode="multiple" onChange={handleChangeValue('param', outIndex, innerIndex)} disabled={isEdit} showSearch={{ optionFilterProp: 'children' }}>
                                                                                            {titleData
                                                                                                && titleData.map(item => {
                                                                                                    return (
                                                                                                        <Select.Option key={item.dicCode} value={item.dicCode}>
                                                                                                            {item.dicName}
                                                                                                        </Select.Option>
                                                                                                    );
                                                                                                })}
                                                                                        </Select>
                                                                                    )}
                                                                                    {code === 'member.mem_device_type' && (
                                                                                        <Select value={param ? param.split(/[,]/) : undefined} placeholder="请选择注册端口" mode="multiple" onChange={handleChangeValue('param', outIndex, innerIndex)} disabled={isEdit}>
                                                                                            <Select.Option value="app">APP</Select.Option>
                                                                                            <Select.Option value="wap">WAP</Select.Option>
                                                                                            <Select.Option value="pc">PC</Select.Option>
                                                                                        </Select>
                                                                                    )}
                                                                                    {!isEdit && (
                                                                                        <Tooltip placement="right" title="单个或英文逗号隔开的多个值">
                                                                                            <span className="user-group-tooltip">
                                                                                                <i className="bi bi-info-circle-fill"></i>
                                                                                            </span>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                </Col>
                                                                            </Fragment>
                                                                        ) : (
                                                                            <Fragment></Fragment>
                                                                        )}

                                                                        {/* 注册时间    认证审核时间    最后登录时间*/}
                                                                        {code === '<time>member.mem_regist_time' && (
                                                                            <Fragment>
                                                                                <Col className="gutter-row" span={4}>
                                                                                    <Select value="range" disabled style={{ width: '100%' }}>
                                                                                        <Option value="range">区间</Option>
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col className="gutter-row" span={7}>
                                                                                    {isEdit ? (
                                                                                        <RangePicker disabled={true} value={[dayjs(registerTime.startTime, dateFormat), dayjs(registerTime.endTime, dateFormat)]} allowClear={false} showTime />
                                                                                    ) : (
                                                                                        <RangePicker allowClear={false} onChange={handleChangeValue('param', outIndex, innerIndex)} showTime />
                                                                                    )}
                                                                                </Col>
                                                                            </Fragment>
                                                                        )}
                                                                        {code === '<time>member.mem_examine_time' && (
                                                                            <Fragment>
                                                                                <Col className="gutter-row" span={4}>
                                                                                    <Select value="range" disabled style={{ width: '100%' }}>
                                                                                        <Option value="range">区间</Option>
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col className="gutter-row" span={7}>
                                                                                    {isEdit ? (
                                                                                        <RangePicker disabled={true} value={[dayjs(identityTime.startTime, dateFormat), dayjs(identityTime.endTime, dateFormat)]} allowClear={false} showTime />
                                                                                    ) : (
                                                                                        <RangePicker allowClear={false} onChange={handleChangeValue('param', outIndex, innerIndex)} showTime />
                                                                                    )}
                                                                                </Col>
                                                                            </Fragment>
                                                                        )}
                                                                        {code === '<time>member.mem_lastest_login_time' && (
                                                                            <Fragment>
                                                                                <Col className="gutter-row" span={4}>
                                                                                    <Select value="range" disabled style={{ width: '100%' }}>
                                                                                        <Option value="range">区间</Option>
                                                                                    </Select>
                                                                                </Col>
                                                                                <Col className="gutter-row" span={7}>
                                                                                    {isEdit ? (
                                                                                        <RangePicker disabled={true} value={[dayjs(lastTime.startTime, dateFormat), dayjs(lastTime.endTime, dateFormat)]} allowClear={false} showTime />
                                                                                    ) : (
                                                                                        <RangePicker allowClear={false} onChange={handleChangeValue('param', outIndex, innerIndex)} showTime />
                                                                                    )}
                                                                                </Col>
                                                                            </Fragment>
                                                                        )}
                                                                        {!isEdit && <i className="bi bi-x"></i>}
                                                                    </Row>
                                                                );
                                                            })}
                                                        {!isEdit && list.length !== 0 && ListLength < 5 && (
                                                            <div className="inner-add">
                                                                <span onClick={handleAddInner(outIndex)} className="user-add-box">
                                                                    <i className="bi bi-plus-circle"></i>
                                                                    新增
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {!isEdit && (
                        <Form.Item>
                            <Space className="user-group-submit">
                                <Button className="submit-button" type="primary" htmlType="submit">
                                    提交
                                </Button>
                                <Button type="default" onClick={handleClose}>
                                    取消
                                </Button>
                            </Space>
                        </Form.Item>
                    )}
                </Form>
            </div>
        </Fragment>
    );
}
